import './header.scss';

import { CHeader, CHeaderNav } from '@coreui/react';
import React from 'react';

import { Currency } from '../currency/Currency';
import { CurrencyStandalone } from '../currency/CurrencyStandlone';
import { Language } from '../language/Language';

export interface HeaderProps {
  showCurrency?: boolean;
  showCurrencyStandalone?: boolean;
}

export const Header: React.FC<HeaderProps> = ({
  showCurrency = true,
  showCurrencyStandalone = false,
}) => {

  return (
    <CHeader className="d-flex justify-content-end align-items-center page-header position-sticky">
      <CHeaderNav className="px-3">
        {showCurrency && <Currency />}
        {showCurrencyStandalone && <CurrencyStandalone />}
        <Language />
      </CHeaderNav>
    </CHeader>
  );
};
